import { __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
/**
 * Client for making User Management Service API calls.
 */
var UserTenantMgtSvcClient = /** @class */ (function (_super) {
    __extends(UserTenantMgtSvcClient, _super);
    function UserTenantMgtSvcClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/usermgtsvc';
        _this.apiVersion = '3';
        _this.userTenantDetailsEndpoint = '/usertenantdetails';
        _this.userWithTenantDetailsEndpoint = '/userwithtenantdetails';
        _this.externalUserEndpoint = '/externaluserdetails';
        _this.usersEndPoint = '/users';
        _this.idpPropsEndPoint = 'idpproperties';
        _this.meEndpoint = '/me';
        return _this;
    }
    /**
     * Get IT Admins information for a Tenant/Customer.
     * @param {string} resourceId tenant's/customer's resourceid
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.getUserWithTenantDetails = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.userWithTenantDetailsEndpoint, "?tenantResourceId=").concat(resourceId, "&roleCategory=Admin"),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            });
        });
    };
    /**
     * This endpoint partially updates User's Tenant.
     * @param {UserTenantDetailPatchRequest} user's tenant request metadata required to patch.
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.updateUserWithTenantDetails = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.patch({
                        url: "".concat(this.userTenantDetailsEndpoint),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        data: data,
                    })];
            });
        });
    };
    /**
     * Returns the expected schema for user tenant detail response object.
     *
     * @returns schema in object format
     */
    UserTenantMgtSvcClient.getCurrentActiveUserSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: [
                'resourceId',
                'systemTenantResourceId',
                'fqTenantId',
                'tenantResourceId',
                'tenantType',
                'userResourceId',
            ],
            additionalProperties: true,
            properties: {
                resourceId: {
                    type: 'string',
                },
                systemTenantResourceId: {
                    type: 'string',
                },
                fqTenantId: {
                    type: 'string',
                },
                tenantResourceId: {
                    type: 'string',
                },
                tenantType: {
                    type: 'string',
                },
                userResourceId: {
                    type: 'string',
                },
            },
        };
    };
    /**
     * Get current active user information.
     *
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.getCurrentActiveUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.userTenantDetailsEndpoint).concat(this.meEndpoint),
                        validationSchema: UserTenantMgtSvcClient.getCurrentActiveUserSchema(),
                    })];
            });
        });
    };
    /**
     * Get current active user with tenant information.
     *
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.getCurrentActiveUserWithTenant = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.userWithTenantDetailsEndpoint).concat(this.meEndpoint),
                    })];
            });
        });
    };
    /**
     * Get a Users list on behalf of the authenticated user.
     *
     * @param {string} tenantResourceId tenant's resourse id
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.getUserWithTenantList = function (tenantResourceId, maxResult) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: this.userWithTenantDetailsEndpoint,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        params: { tenantResourceId: tenantResourceId, maxResult: maxResult },
                    })];
            });
        });
    };
    /**
     * Get a Users list on behalf of the authenticated user.
     *
     * @param {string} tenantResourceId tenant's resourse id
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.getUserWithTenantForSP = function (tenantResourceId, userResourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: this.userWithTenantDetailsEndpoint,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        params: {
                            tenantResourceId: tenantResourceId,
                            userResourceId: userResourceId,
                        },
                    })];
            });
        });
    };
    /**
     * Get a External Users list (invited users list) on behalf of the authenticated user.
     *
     * @param {string} tenantResourceId tenant's resourse id
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.getExternalUserList = function (tenantResourceId, maxResult) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.externalUserEndpoint, "/").concat(tenantResourceId),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        params: { maxResult: maxResult },
                    })];
            });
        });
    };
    /**
     * Update External Users role on behalf of the authenticated user.
     *
     * @param {string} roleResourceId user role resourse id
     * @param {string} userResourceId user's resourse id
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.updateExternalUserRole = function (userResourceId, roleResourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.patch({
                        url: "".concat(this.externalUserEndpoint, "/").concat(userResourceId),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        data: { roleResourceId: roleResourceId },
                    })];
            });
        });
    };
    /**
     * Get a Personal details of the user on behalf of the authenticated user.
     *
     * @param {string} resourceId user's resourse id
     * @returns Axios response object
     */
    UserTenantMgtSvcClient.prototype.getUserPersonalDetails = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.usersEndPoint, "/").concat(resourceId, "/").concat(this.idpPropsEndPoint),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            });
        });
    };
    return UserTenantMgtSvcClient;
}(StratusClient));
export { UserTenantMgtSvcClient };
//# sourceMappingURL=user-tenant-mgt-svc.js.map